/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_teacher': {
    width: 16,
    height: 16,
    viewBox: '0 0 15.855 14',
    data: '<g data-name="Group 3374"><g data-name="Group 3373"><path pid="0" data-name="Path 17807" d="M13.527 2.322a7.911 7.911 0 00-11.2 0A7.841 7.841 0 000 7.907v3.012a13.088 13.088 0 012.1-1.12 1.726 1.726 0 011.627-2.3H6.21a1.731 1.731 0 011.632 1.159h.182a1.733 1.733 0 011.629-1.153h2.477a1.721 1.721 0 011.626 2.3 13.089 13.089 0 012.1 1.119V7.907a7.841 7.841 0 00-2.329-5.585z" _fill="#959ba6"/></g></g><g data-name="Group 3376"><g data-name="Group 3375"><path pid="1" data-name="Path 17808" d="M13.139 10.612l-.027.02a1.7 1.7 0 01-.983.312H9.653a1.737 1.737 0 01-1.674-1.319h-.093a1.745 1.745 0 01-.455.808 1.708 1.708 0 01-1.221.512H3.728a1.705 1.705 0 01-.985-.313l-.026-.019A12 12 0 000 12.135v1.864h15.855v-1.864a11.994 11.994 0 00-2.716-1.523z" _fill="#959ba6"/></g></g>'
  }
})
